import { createContext, useContext } from 'react';

/* eslint-disable-next-line no-restricted-imports */
import type { BrandPartner } from '@jane/shared/models';

const BrandPartnerContext = createContext<BrandPartner | undefined>(undefined);

export const useBrandPartnerContext = () => useContext(BrandPartnerContext);
